import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatTime', pure: true })
export class FormatTimePipe implements PipeTransform {
  transform(seconds: number): string {
    if (!seconds || !Number.isFinite(seconds)) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  }
}
